
import { HashLocationStrategy, LocationStrategy } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AgmCoreModule, GoogleMapsAPIWrapper } from '@agm/core';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { AuthGuard } from './guards/auth.guard';
import { MainAuthGuard } from './guards/main-auth.guard';
import { FlexLayoutModule } from "@angular/flex-layout";
import { MalihuScrollbarModule } from 'ngx-malihu-scrollbar';
import { AgularMaterialModule } from './material.module';
import { OwlDateTimeModule, OwlNativeDateTimeModule } from 'ng-pick-datetime';

// Services
import { AuthService, MainService, PaginationService, BaseLoaderService } from './services';

// Lib
import { FilterDatePipe, AlertDialog, PaginationComponent } from './lib';

// Config
// import { appConfig } from '../config';

// Directives
import { ClickOutsideDirective } from './directives/click-outside.directive';

// Page Components
import { LoginComponent } from './views/auth/login/login.component';
import { TemplateMainApp } from './templates/template-main-app/template-main-app.component';
import { ForgotPasswordComponent } from './views/auth/forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './views/auth/reset-password/reset-password.component';
import { AppsGuard } from './guards/apps.guard';
import {DashboardComponent} from "./views/dashboard/dashboard.component";
import {Card} from "./lib/card/card.component";
import {ContractManagement} from "./views/contract-management/contract-management.component";
import {ManageAddress} from "./views/address/manage-address.component";
import {AddAddress} from "./views/address/add-address.component";
import {PastOrders} from "./views/past-orders/past-orders.component";
import {NewRequest} from "./views/new-request/new-request.component";
import {TrackOrders} from "./views/track-orders/track-orders.component";
import {appConfig} from "../config";
import {MapLocationDialog} from "./lib/map-location/map-location.dialog";
import {LocationPickerDialog} from "./lib/location-picker/location_dialog";
import {LocationPicker} from "./lib/location-picker/location-picker";
import {ApiLoaderService} from "./lib/api-loader/api-loader.service";
import {ApiLoaderInterceptorService} from "./lib/api-loader/api-loader.interceptor.service";
import {ApiLoaderComponent} from "./lib/api-loader/api-loader.component";
import {TrackOrdersList} from "./views/track-orders/track-orders-list.component";
import {LocationViewComponent} from "./lib/location-view/location-view.component";
import {LocationMultiViewComponent} from "./lib/location-multi-view/location-multi-view.component";
import { PendingOrdersList } from './views/pending-orders/pending-orders-list.component';
import { OrderDetailComponent } from './views/pending-orders/order_detail.component';


@NgModule({
    imports: [
        BrowserModule,
        FormsModule,
        // HttpModule,
        // TagInputModule,
        HttpClientModule,
        AppRoutingModule,
        ReactiveFormsModule,
        BrowserAnimationsModule,
        AgularMaterialModule,
        AgmCoreModule.forRoot({
            apiKey: appConfig.google_api_key,
            libraries: ['places']
        }),
        FlexLayoutModule,
        MalihuScrollbarModule.forRoot(),
        // NgxEditorModule,
        // NgxMaskModule.forRoot(),
        OwlDateTimeModule,
        OwlNativeDateTimeModule,
        // NgProgressModule,
    ],
    providers: [
        AuthGuard,
        AuthService,
        MainService,
        MainAuthGuard,
        AppsGuard,
        PaginationService,
        BaseLoaderService,
        GoogleMapsAPIWrapper,
        { provide: LocationStrategy, useClass: HashLocationStrategy },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: ApiLoaderInterceptorService,
            multi: true
        },
        ApiLoaderService
        // { provide: OWL_DATE_TIME_FORMATS, useValue: 'fr' },
        // {provide: HTTP_INTERCEPTORS, useClass: NgProgressInterceptor, multi: true },
    ],
    declarations: [
        ApiLoaderComponent,

        AppComponent,
        LoginComponent,
        TemplateMainApp,
        AlertDialog,
        ClickOutsideDirective,
        PaginationComponent,
        ForgotPasswordComponent,
        ResetPasswordComponent,
        FilterDatePipe,
        DashboardComponent,
        Card,
        ContractManagement,
        ManageAddress,
        AddAddress,
        PastOrders,
        NewRequest,
        TrackOrders,
        TrackOrdersList,
        MapLocationDialog,
        LocationPicker,
        LocationPickerDialog,
        LocationViewComponent,
        LocationMultiViewComponent,
        PendingOrdersList,
        OrderDetailComponent
    ],
    entryComponents: [
        AlertDialog,
        MapLocationDialog,
        LocationPickerDialog,
        LocationViewComponent,
        LocationMultiViewComponent,
        OrderDetailComponent
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }
